import React, { useState, useEffect } from 'react'

import * as R from 'ramda'
import Spinner from '../../../UniformComponents/Spinner'
import WidgetContainer from '../WidgetContainer'
import Button from '../../../UniformComponents/Button'

const ChartPreview = (props) => {
    const [loading, setLoading] = useState(true)
    const [data, setData] = useState({})
    const {
        dashboardWizardStore, isOpen, close, chart,
    } = props
    const {
        dashStore, appStore, getDefaultTitle,
    } = dashboardWizardStore

    const { getChartData } = dashStore

    useEffect(() => {
        const getDashboardData = async () => {
            const widget = dashboardWizardStore.addWidget(true)
            const chartData = await getChartData([widget])
            setData(chartData[0])
            setLoading(false)
        }
        if (isOpen) getDashboardData()
    }, [isOpen])

    if (!isOpen) return null

    return (
        <div style={{
            position: 'absolute',
            width: '921px',
            height: '370px',
            top: '192px',
            left: '-8px',
            zIndex: '500000',
        }}
        >
            <div style={{ width: '100%', height: '370px' }}>
                {loading
                    ? (
                        <div style={{
                            backgroundColor: 'white',
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: '15px',
                        }}
                        >
                            <Spinner />
                            <Button cssClass="primary regular" onClick={close}>Cancel</Button>
                        </div>
                    )
                    : (
                        <WidgetContainer
                            renderChart
                            chart={dashStore.getChart({
                                ...data,
                                title: getDefaultTitle(),
                                containerSize: { height: 370, width: 921 },
                            }, data.data)}
                            removeChart={close}
                            chartKey={chart}
                            title={getDefaultTitle()}
                            DynamicDashboardStore={dashStore}
                            preview
                        />
                    )}
            </div>
        </div>
    )
}

export default ChartPreview
